var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirtualUrgentCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#6062ca;stroke-width:.2px;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{fill:#6062ca;}.cls-6{mask:url(#mask);}.cls-7,.cls-8{fill:#e2e2fb;}.cls-7,.cls-8,.cls-3,.cls-4,.cls-9,.cls-10,.cls-11{stroke-width:0px;}.cls-2,.cls-5{stroke:#e2e2fb;}.cls-8,.cls-4,.cls-9,.cls-11{fill-rule:evenodd;}.cls-9,.cls-10{fill:#fff;}.cls-5{stroke-width:.5px;}.cls-11{fill:#000;}.cls-12{mask:url(#mask-2);}.cls-13{mask:url(#mask-1);}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 19,
    y: 12,
    width: 16,
    height: 16,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-41-outside-1_5837_15307"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 19,
    y: 12,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M27,27c3.87,0,7-3.13,7-7s-3.13-7-7-7-7,3.13-7,7c0,1.24.32,2.41.89,3.42l-.23,2.21c-.08.69.56,1.25,1.24,1.08l1.9-.48c.96.49,2.05.77,3.2.77Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 19,
    y: 12,
    width: 16,
    height: 16,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-43-inside-2_5837_15307"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M27,27c3.87,0,7-3.13,7-7s-3.13-7-7-7-7,3.13-7,7c0,1.24.32,2.41.89,3.42l-.23,2.21c-.08.69.56,1.25,1.24,1.08l1.9-.48c.96.49,2.05.77,3.2.77Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 22.82,
    y: 15.82,
    width: 8.36,
    height: 8.36,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-45-inside-3_5837_15307"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M27.05,16.82c-.51,0-.91.41-.91.91v1.24h-1.41c-.5,0-.91.41-.91.91s.41.91.91.91h1.41v1.49c0,.5.4.91.91.91s.9-.41.9-.91v-1.49h1.32c.5,0,.91-.41.91-.91s-.41-.91-.91-.91h-1.32v-1.24c0-.5-.4-.91-.9-.91Z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 40,
    height: 40,
    rx: 8,
    ry: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.07,10.67h0s0,0-.01,0c-.01,0-.02,0-.03-.01,0,0-.01,0-.01,0-.06-.24-.11-.48-.16-.73,0-.03-.01-.06-.01-.09h4.68s-.02.09-.03.13c-.05.24-.09.47-.15.7,0,0,0,0,0,0-.01,0-.02,0-.03.01,0,0-.01,0-.01,0h-.01c-1.4,0-2.81,0-4.22,0ZM13.9,10.92v18.18c0,.6.2,1.1.56,1.45.37.35.88.54,1.49.54h8.46c.62,0,1.14-.19,1.5-.55.37-.35.57-.86.57-1.46V10.91c0-.61-.2-1.11-.57-1.46-.36-.35-.88-.54-1.5-.54h-8.44c-.63,0-1.15.19-1.51.54-.36.35-.56.86-.56,1.48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.5,
    y: 8.5,
    width: 5,
    height: 2,
    rx: 0.5,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M16.5,29.25h2c.14,0,.25.11.25.25h0c0,.14-.11.25-.25.25h-2c-.14,0-.25-.11-.25-.25h0c0-.14.11-.25.25-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.94,27.87h1.02c.25,0,.4.14.41.35,0,.21-.16.35-.4.35-.71,0-1.41,0-2.11,0-.25,0-.41-.15-.4-.36,0-.21.16-.34.41-.35.36,0,.71,0,1.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M27,27c3.87,0,7-3.13,7-7s-3.13-7-7-7-7,3.13-7,7c0,1.24.32,2.41.89,3.42l-.23,2.21c-.08.69.56,1.25,1.24,1.08l1.9-.48c.96.49,2.05.77,3.2.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M20.89,23.42l1,.11.03-.32-.16-.28-.87.49ZM20.66,25.63l.99.11-.99-.11ZM21.9,26.71l.24.97h0l-.24-.97ZM23.8,26.23l.46-.89-.34-.17-.37.09.25.97ZM33,20c0,3.31-2.69,6-6,6v2c4.42,0,8-3.58,8-8h-2ZM27,14c3.31,0,6,2.69,6,6h2c0-4.42-3.58-8-8-8v2ZM21,20c0-3.31,2.69-6,6-6v-2c-4.42,0-8,3.58-8,8h2ZM21.76,22.93c-.48-.87-.76-1.87-.76-2.93h-2c0,1.42.37,2.76,1.02,3.91l1.74-.98ZM21.65,25.74l.24-2.21-1.99-.21-.24,2.21,1.99.21ZM21.65,25.74h0l-1.99-.21c-.14,1.38,1.13,2.49,2.48,2.15l-.49-1.94ZM23.55,25.26l-1.9.48.49,1.94,1.9-.48-.49-1.94ZM27,26c-.99,0-1.92-.24-2.74-.66l-.92,1.78c1.1.57,2.34.88,3.66.88v-2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M27,27c3.87,0,7-3.13,7-7s-3.13-7-7-7-7,3.13-7,7c0,1.24.32,2.41.89,3.42l-.23,2.21c-.08.69.56,1.25,1.24,1.08l1.9-.48c.96.49,2.05.77,3.2.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.89,23.42l1,.11.03-.32-.16-.28-.87.49ZM20.66,25.63l.99.11-.99-.11ZM21.9,26.71l.24.97h0l-.24-.97ZM23.8,26.23l.46-.89-.34-.17-.37.09.25.97ZM33,20c0,3.31-2.69,6-6,6v2c4.42,0,8-3.58,8-8h-2ZM27,14c3.31,0,6,2.69,6,6h2c0-4.42-3.58-8-8-8v2ZM21,20c0-3.31,2.69-6,6-6v-2c-4.42,0-8,3.58-8,8h2ZM21.76,22.93c-.48-.87-.76-1.87-.76-2.93h-2c0,1.42.37,2.76,1.02,3.91l1.74-.98ZM21.65,25.74l.24-2.21-1.99-.21-.24,2.21,1.99.21ZM21.65,25.74h0l-1.99-.21c-.14,1.38,1.13,2.49,2.48,2.15l-.49-1.94ZM23.55,25.26l-1.9.48.49,1.94,1.9-.48-.49-1.94ZM27,26c-.99,0-1.92-.24-2.74-.66l-.92,1.78c1.1.57,2.34.88,3.66.88v-2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.05,16.82c-.51,0-.91.41-.91.91v1.24h-1.41c-.5,0-.91.41-.91.91s.41.91.91.91h1.41v1.49c0,.5.4.91.91.91s.9-.41.9-.91v-1.49h1.32c.5,0,.91-.41.91-.91s-.41-.91-.91-.91h-1.32v-1.24c0-.5-.4-.91-.9-.91Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.14,18.96v1h1v-1h-1ZM26.14,20.78h1v-1h-1v1ZM27.95,20.78v-1h-1v1h1ZM27.95,18.96h-1v1h1v-1ZM27.14,17.73c0,.05-.04.09-.09.09v-2c-1.06,0-1.91.85-1.91,1.91h2ZM27.14,18.96v-1.24h-2v1.24h2ZM24.73,19.96h1.41v-2h-1.41v2ZM24.82,19.87c0,.05-.04.09-.09.09v-2c-1.06,0-1.91.85-1.91,1.91h2ZM24.73,19.78c.05,0,.09.04.09.09h-2c0,1.05.85,1.91,1.91,1.91v-2ZM26.14,19.78h-1.41v2h1.41v-2ZM27.14,22.27v-1.49h-2v1.49h2ZM27.05,22.18s.09.04.09.09h-2c0,1.05.85,1.91,1.91,1.91v-2ZM26.95,22.27c0-.05.05-.09.1-.09v2c1.05,0,1.9-.85,1.9-1.91h-2ZM26.95,20.78v1.49h2v-1.49h-2ZM29.27,19.78h-1.32v2h1.32v-2ZM29.18,19.87c0-.05.04-.09.09-.09v2c1.06,0,1.91-.85,1.91-1.91h-2ZM29.27,19.96c-.05,0-.09-.04-.09-.09h2c0-1.05-.85-1.91-1.91-1.91v2ZM27.95,19.96h1.32v-2h-1.32v2ZM26.95,17.73v1.24h2v-1.24h-2ZM27.05,17.82s-.1-.04-.1-.09h2c0-1.05-.85-1.91-1.9-1.91v2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualUrgentCare);
export default __webpack_public_path__ + "static/media/Virtual Urgent Care.5a4c3ca6966a9afb9d403080ab1b0275.svg";
export { ForwardRef as ReactComponent };